import "./GreenButton.scss";

const GreenButton = () => {
  return <div className="wrapper">NEW!</div>;
};

export default GreenButton;
